import React, { Component } from "react";
import classnames from "classnames";

import { Fader } from "@formant/ui/component/common/Fader";

import { ITab } from "./ITab";
import * as styles from "./TabContent.scss";

export interface ITabContentProps {
    tabs: ITab[];
    selected: string;
    className?: string;
}

export class TabContent extends Component<ITabContentProps> {
    public render() {
        const { tabs, selected, className } = this.props;
        return (
            <div className={classnames(styles["tab-content"], className)}>
                {tabs.map(({ name, content }) => (
                    <Fader
                        key={name}
                        visible={selected === name}
                        className={styles.content}
                    >
                        {content}
                    </Fader>
                ))}
            </div>
        );
    }
}
